// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7446e4a","514":"70af5043","529":"99531a56","881":"1e16e9e2","982":"7ac2da7a"}[chunkId] + ".chunk.js";
};